import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import utils from '../../../../../utils/utils';
import { user } from '../../../../../redux/user';
import { PERMISSION as PERMISSIONS } from '../../../../../constants';
import actionsIcon from '../../../../../assets/images/docs.svg';
import config from '../../../../../config';

const FlexCredentialDownloadAction = ({ managementCompanyId, caregiverId, credentialType, credentialId, fileId }) => {
	const userData = useSelector(user, shallowEqual);

	const hasDownloadPermission = utils.isAuthorizedExact(
		PERMISSIONS.WORKFORCE_CREDENTIALS_DOWNLOAD,
		userData.managementCompanyPermissions[managementCompanyId]
	);

	const onClick = () => {
		return (
			hasDownloadPermission &&
			window.open(
				`${config.API_URL}/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/credentials/${credentialType}/${credentialId}/file`,
				'_blank'
			)
		);
	};

	if (!fileId) return null;

	return (
		<OverlayTrigger
			placement="bottom-end"
			trigger={['hover']}
			overlay={
				<Tooltip className="download-permission-tooltip">
					{hasDownloadPermission ? 'View attachment' : 'You do not have permission to view this attachment'}
				</Tooltip>
			}
		>
			<Button
				type="button"
				className={classNames('btn actions', { 'download-disabled': !hasDownloadPermission })}
				onClick={onClick}
				aria-controls="popup_menu_left"
				aria-haspopup
			>
				<img src={actionsIcon} alt="download" />
			</Button>
		</OverlayTrigger>
	);
};

export default FlexCredentialDownloadAction;
